import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/announce-hanging.svg'
import _imports_1 from '@/app/ui/assets/svg/sync-hanging.svg'
import _imports_2 from '@/app/ui/assets/svg/scan-hanging.svg'
import _imports_3 from '@/app/ui/assets/svg/history-hanging.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-cf1fea84")

_pushScopeId("data-v-cf1fea84")
const _hoisted_1 = { class: "bg-white p-3 flex flex-col gap-3 rounded-2xl" }
const _hoisted_2 = { class: "flex gap-6 justify-between items-center" }
const _hoisted_3 = { class: "text-black-lp-200" }
const _hoisted_4 = { class: "text-xl font-bold" }
const _hoisted_5 = { class: "flex gap-1" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "announce-hanging"
}, null, -1)
const _hoisted_7 = { class: "text-xs" }
const _hoisted_8 = { class: "text-black-lp-200 font-bold text-sm" }
const _hoisted_9 = { class: "text-black-lp-200 font-bold text-sm" }
const _hoisted_10 = { class: "text-black-lp-200 font-bold text-sm" }
const _hoisted_11 = { class: "mb-2 flex text-green-lp-100 gap-1 text-sm" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "sync-hanging"
}, null, -1)
const _hoisted_13 = { class: "font-semibold mr-0.5" }
const _hoisted_14 = { class: "italic" }
const _hoisted_15 = { class: "flex gap-2 justify-end" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "mr-2"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "mr-2"
}, null, -1)
const _hoisted_18 = { class: "grid-custom" }
const _hoisted_19 = { class: "flex flex-col gap-2 px-3" }
const _hoisted_20 = { class: "flex text-sm text-gray-lp-300 items-center justify-center" }
const _hoisted_21 = { class: "class-bottom-card text-black-lp-200 px-3 py-1 rounded-2xl flex justify-center items-center text-xs" }
const _hoisted_22 = { class: "text-sm font-bold" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('dashboard.hanging.dashboardTitleOutgoing')), 1),
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.$t('dashboard.hanging.outgoingInfoPrefix')) + " ", 1),
            _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('dashboard.hanging.day3Plus')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.hanging.outgoingInfoOnStatus')) + " ", 1),
            _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('dashboard.hanging.outgoingInfoStatuses')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.hanging.outgoingInfoActionPrefix')) + " ", 1),
            _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('dashboard.hanging.outgoingInfoAction')), 1)
          ])
        ])
      ]),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('dashboard.hanging.syncLast')), 1),
          _createVNode("span", _hoisted_14, _toDisplayString(_ctx.formatDate(_ctx.dataSummary.lastSync, 'DD MMMM YYYY, HH:mm')), 1)
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("button", {
            id: "btn-search-stt-hanging-last-mile",
            class: "flex items-center text-sm bg-red-lp-100 text-white px-4 py-2 rounded-md font-semibold",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/cari-stt/scan')))
          }, [
            _hoisted_16,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.hanging.searchStt')), 1)
          ]),
          _createVNode("button", {
            id: "btn-history-hanging-last-mile",
            class: "flex items-center text-sm bg-white text-red-lp-100 px-4 py-2 rounded-md font-semibold border border-red-lp-100",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/dashboard/history-hanging-outgoing')))
          }, [
            _hoisted_17,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.hanging.history')), 1)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_18, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allCards, (c, i) => {
        return (_openBlock(), _createBlock("div", {
          key: i,
          class: "flex flex-col gap-2"
        }, [
          _createVNode("div", {
            class: ["flex flex-col pt-3 gap-2 rounded-2xl justify-between bg-white border border-b-0 border-gray-lp-1400", i === 0 ? 'class-activity' : '']
          }, [
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _createVNode("img", {
                  src: c.icon,
                  alt: c.alt,
                  class: "mr-2"
                }, null, 8, ["src", "alt"]),
                _createVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('dashboard.hanging.total')), 1),
                  _createVNode("span", {
                    class: ["text-black-lp-200 px-1", i === 0 ? '' : 'font-bold']
                  }, _toDisplayString(c.label), 3),
                  _createTextVNode(" " + _toDisplayString(i === 0 ? _ctx.$t('dashboard.hanging.mustBeDone') : i == _ctx.allCards.length-1 ? _ctx.$t('dashboard.hanging.hanging') : ''), 1)
                ])
              ]),
              _createVNode("div", {
                class: ["flex justify-center font-bold   h-16 items-center", i === 0 ? 'text-red-lp-2000 text-5xl' : 'text-black-lp-200 text-34px']
              }, _toDisplayString(c.pending || 0), 3)
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode("p", null, [
                _createVNode("span", _hoisted_22, _toDisplayString(c.done || 0), 1),
                _createTextVNode("/" + _toDisplayString(c.total || 0) + " " + _toDisplayString(i === 0 ? _ctx.$t('dashboard.hanging.activityDone') : _ctx.$t('dashboard.hanging.processedToday')), 1)
              ])
            ])
          ], 2)
        ]))
      }), 128))
    ])
  ]))
})